import { useTranslation } from 'react-i18next';

/**
 * Picks the field for the active language.
 *
 * Reference books carry both languages in separate columns rather than through
 * i18n resources, because they are data the user can edit — a renamed package
 * has to keep its new name, and a translation file cannot hold that.
 */
export function useLabel() {
  const { i18n } = useTranslation();
  const isRussian = i18n.language.startsWith('ru');

  return {
    isRussian,
    pick(ru: string | null | undefined, en: string | null | undefined): string {
      const preferred = isRussian ? ru : en;
      return preferred || en || ru || '';
    },
  };
}
